(function() {
  function fixPrice() {
    try {
      var priceEls = document.querySelectorAll('.price__regular, .price-item, .price-item--regular');
      priceEls.forEach(function(el) {
        if (el.closest('.purchase-option-wrapper')) return;
        if (el.closest('.product-sticky-form__card')) return;
        if (el.querySelector('.lykyn-dollar')) return;
        if (el.querySelector('.price-item, .price-item--regular, .money')) return;
        var text = el.textContent.trim();
        if (text.charAt(0) === '$') {
          var amount = text.substring(1);
          el.innerHTML = '<span class="lykyn-dollar" style="font-size:11px !important;vertical-align:super;margin-right:2px;color:#685F5A;">$</span>' + amount;
          el.style.setProperty('font-size', '28px', 'important');
          el.style.setProperty('color', '#685F5A', 'important');
          el.style.setProperty('font-family', 'Neuton, Georgia, serif', 'important');
          el.style.setProperty('line-height', '1.2', 'important');
        }
      });
      document.querySelectorAll('.product .money').forEach(function(el) {
        if (el.closest('.purchase-option-wrapper')) return;
        if (el.closest('.product-sticky-form__card')) return;
        if (el.querySelector('.lykyn-dollar')) return;
        var text = el.textContent.trim();
        if (text.charAt(0) === '$') {
          var amount = text.substring(1);
          el.innerHTML = '<span class="lykyn-dollar" style="font-size:11px !important;vertical-align:super;margin-right:2px;color:#685F5A;">$</span>' + amount;
        }
      });
    } catch(e) {}
  }

  function fixSssInfo() {
    document.querySelectorAll('.sss-information').forEach(function(el) {
      var tooltipText = el.querySelector('.tooltip-text');
      var hasContent = tooltipText && tooltipText.textContent.trim().length > 3;
      if (hasContent) {
        el.style.cssText = 'display:inline-flex!important;align-items:center!important;gap:6px!important;font-size:13px!important;color:#685F5A!important;width:auto!important;height:auto!important;max-width:100%!important;';
        var svg = el.querySelector('svg');
        if (svg) svg.style.cssText = 'width:16px!important;height:16px!important;min-width:16px!important;flex-shrink:0!important;';
      } else {
        el.style.cssText = 'display:none!important;';
      }
    });
  }

  function fixSssBadge() {
    document.querySelectorAll('.ss-subscriptions-discount-badge').forEach(function(badge) {
      badge.style.cssText = 'background:#D16014!important;color:#FFFFFF!important;border:none!important;border-radius:6px!important;padding:6px 14px!important;font-size:11px!important;font-weight:600!important;letter-spacing:0.5px!important;text-transform:uppercase!important;position:static!important;margin-left:8px!important;animation:none!important;transform:none!important;';
    });
  }

  function applyLykynStyles() {
    var header = document.querySelector('.header');
    if (header) { header.style.borderRadius = '8px'; header.style.overflow = 'visible'; header.style.clipPath = 'none'; }
    var headerSection = document.querySelector('.header-section');
    if (headerSection) {
      headerSection.style.overflow = 'visible'; headerSection.style.clipPath = 'none';
      headerSection.querySelectorAll('.cutout, .corner, [class*="corner"]').forEach(function(el) { el.style.display = 'none'; });
    }

    document.querySelectorAll('.installment, shopify-payment-terms, [class*="shopify-payment-terms"], .spi-banner-container, .spi-banner').forEach(function(el) { el.style.display = 'none'; });

    fixPrice();
    fixSssInfo();
    fixSssBadge();

    document.querySelectorAll('.purchase-options-wrapper').forEach(function(el) {
      el.style.cssText = 'border:none!important;background:transparent!important;box-shadow:none!important;outline:none!important;padding:0!important;';
    });
    document.querySelectorAll('.purchase-options-wrapper style, .purchase-option-wrapper style').forEach(function(el) { el.textContent = ''; });

    document.querySelectorAll('.purchase-option-wrapper').forEach(function(el) {
      el.style.cssText = 'border:1.5px solid #E8E2DC!important;border-radius:10px!important;background:#FFFFFF!important;padding:10px 14px!important;margin:4px 0!important;cursor:pointer;overflow:hidden;font-size:13px!important;';
      var radio = el.querySelector('input[type="radio"]');
      if (radio && radio.checked) { el.style.borderColor = '#685F5A'; el.style.background = 'rgba(104,95,90,0.04)'; }
    });

    document.querySelectorAll('.purchase-option-details_background').forEach(function(el) { el.style.display = 'none'; });
    document.querySelectorAll('.purchase-option-details, .purchase-option-details-content, .purchase-option-details-content-container, .purchase-option-price-container').forEach(function(el) {
      el.style.cssText = 'border:none!important;background:transparent!important;box-shadow:none!important;outline:none!important;';
    });

    document.querySelectorAll('.purchase-option-wrapper').forEach(function(wrapper) {
      wrapper.querySelectorAll('*').forEach(function(el) {
        if (el.tagName !== 'INPUT' && el.tagName !== 'STYLE') { el.style.color = '#685F5A'; el.style.border = 'none'; el.style.outline = 'none'; el.style.boxShadow = 'none'; el.style.background = 'transparent'; }
      });
    });

    document.querySelectorAll('.product-form__submit, button[name="add"]').forEach(function(btn) {
      btn.style.cssText = 'background:#D16014!important;color:#FFFFFF!important;border:none!important;border-radius:12px!important;overflow:hidden!important;outline:none!important;box-shadow:none!important;padding:15px 24px!important;min-height:unset!important;height:auto!important;font-size:13px!important;width:100%!important;';
      btn.querySelectorAll('*').forEach(function(child) {
        if (child.classList.contains('btn-fill')) { child.style.display = 'none'; }
        else { child.style.borderRadius = '12px'; child.style.border = 'none'; child.style.outline = 'none'; child.style.boxShadow = 'none'; child.style.background = 'transparent'; }
      });
    });

    document.querySelectorAll('media-dots, .product__thumbnails-list').forEach(function(el) {
      if (window.innerWidth <= 1023) {
        el.style.cssText = 'display:flex!important;flex-wrap:nowrap!important;gap:8px!important;justify-content:center!important;align-items:center!important;overflow:visible!important;width:100%!important;max-width:100%!important;padding:0!important;margin:0 auto!important;position:absolute!important;bottom:12px!important;left:0!important;right:0!important;z-index:10!important;pointer-events:auto!important;';
      } else {
        el.style.cssText = 'display:flex!important;flex-wrap:wrap!important;gap:8px!important;justify-content:center!important;overflow:visible!important;width:100%!important;max-width:100%!important;padding:8px 0 0 0!important;margin:0 auto!important;';
      }
    });
    var mediaDots = document.querySelector('media-dots');
    if (mediaDots) {
      var parent = mediaDots.parentElement;
      while (parent && !parent.classList.contains('product__gallery-container') && !parent.classList.contains('product')) {
        parent.style.overflow = 'visible'; parent.style.width = '100%'; parent.style.maxWidth = '100%';
        parent.style.display = 'flex'; parent.style.justifyContent = 'center'; parent = parent.parentElement;
      }
    }

    try {
      document.querySelectorAll('.product .variant__button-label, .product label.variant__button-label').forEach(function(label) {
        var input = label.previousElementSibling;
        if (!input || input.tagName !== 'INPUT') { input = label.parentElement ? label.parentElement.querySelector('input') : null; }
        var isChecked = input && input.checked;
        if (isChecked) { label.style.setProperty('border', '2px solid #685F5A', 'important'); label.style.setProperty('background', 'rgba(104,95,90,0.04)', 'important'); label.style.setProperty('font-weight', '600', 'important'); }
        else { label.style.setProperty('border', '1.5px solid #E8E2DC', 'important'); label.style.setProperty('background', 'transparent', 'important'); }
        label.style.setProperty('border-radius', '10px', 'important');
        label.style.setProperty('color', '#685F5A', 'important');
        label.style.setProperty('transform', 'none', 'important');
        label.style.setProperty('outline', 'none', 'important');
        if (label.querySelector('img')) {
          label.style.setProperty('padding', '4px', 'important');
          var img = label.querySelector('img');
          img.style.setProperty('width', '56px', 'important'); img.style.setProperty('height', '56px', 'important');
          img.style.setProperty('border-radius', '8px', 'important'); img.style.setProperty('object-fit', 'cover', 'important');
        }
      });
    } catch(e) {}

    var isMobile = window.innerWidth <= 1023;

    document.querySelectorAll('.product__thumbnail').forEach(function(el) {
      if (isMobile) {
        el.style.cssText = 'width:10px!important;height:10px!important;flex:0 0 10px!important;min-width:10px!important;min-height:10px!important;max-width:10px!important;max-height:10px!important;border-radius:50%!important;background:rgba(255,255,255,0.5)!important;opacity:1!important;overflow:hidden!important;outline:none!important;border:none!important;padding:0!important;aspect-ratio:1/1!important;transition:background 0.25s ease,transform 0.25s ease!important;';
        var isActive = el.getAttribute('aria-current') === 'true';
        if (isActive) {
          el.style.setProperty('background', '#FFFFFF', 'important');
          el.style.setProperty('transform', 'scale(1.25)', 'important');
        }
        el.querySelectorAll('img, picture, svg, video, .media, [class*="media"]').forEach(function(child) {
          child.style.setProperty('display', 'none', 'important');
          child.style.setProperty('width', '0', 'important');
          child.style.setProperty('height', '0', 'important');
        });
      } else {
        el.style.border = 'none'; el.style.outline = 'none'; el.style.overflow = 'visible';
        el.style.borderRadius = '8px'; el.style.background = 'transparent';
        el.style.width = '64px'; el.style.height = '64px'; el.style.flex = '0 0 64px';
        var isActive = el.getAttribute('aria-current') === 'true';
        if (isActive) { el.style.outline = '2.5px solid #685F5A'; el.style.outlineOffset = '-1px'; el.style.boxShadow = 'none'; el.style.opacity = '1'; }
        else { el.style.outline = 'none'; el.style.boxShadow = 'none'; el.style.opacity = '0.5'; }
        var img = el.querySelector('img');
        if (img) { img.style.borderRadius = '6px'; img.style.background = 'transparent'; }
      }
    });

    document.querySelectorAll('.product-sticky-form__card').forEach(function(el) {
      el.style.background = '#FFFFFF'; el.style.borderTop = '1px solid #E8E2DC'; el.style.boxShadow = '0 -2px 12px rgba(0,0,0,0.04)';
    });
    document.querySelectorAll('.product-sticky-form__card .button--primary, .product-sticky-form__card button[name="add"], .product-sticky-form__card .button').forEach(function(btn) {
      btn.style.cssText = 'background:#D16014!important;color:#FFFFFF!important;border:none!important;border-radius:12px!important;overflow:hidden!important;box-shadow:none!important;outline:none!important;';
      btn.querySelectorAll('*').forEach(function(child) {
        if (child.classList.contains('btn-fill')) { child.style.display = 'none'; }
        else { child.style.borderRadius = '12px'; child.style.border = 'none'; child.style.outline = 'none'; child.style.boxShadow = 'none'; child.style.background = 'transparent'; }
      });
    });
  }

  function setupRadioListeners() {
    document.querySelectorAll('.purchase-option-wrapper input[type="radio"], .purchase-option-wrapper').forEach(function(el) {
      el.addEventListener('click', function() {
        setTimeout(function() {
          document.querySelectorAll('.purchase-option-wrapper').forEach(function(opt) {
            opt.style.cssText = 'border:1.5px solid #E8E2DC!important;border-radius:10px!important;background:#FFFFFF!important;padding:10px 14px!important;margin:4px 0!important;cursor:pointer;overflow:hidden;font-size:13px!important;';
          });
          document.querySelectorAll('.purchase-option-wrapper input[type="radio"]').forEach(function(radio) {
            if (radio.checked) { var wrapper = radio.closest('.purchase-option-wrapper'); if (wrapper) { wrapper.style.borderColor = '#685F5A'; wrapper.style.borderWidth = '2px'; wrapper.style.background = 'rgba(104,95,90,0.04)'; } }
          });
          fixSssInfo(); fixSssBadge();
        }, 100);
        setTimeout(function() { fixSssInfo(); fixSssBadge(); }, 500);
        setTimeout(function() { fixSssInfo(); }, 1000);
      });
    });
  }

  function setupVariantListeners() {
    document.querySelectorAll('.product .variant__button-label, .product label.variant__button-label').forEach(function(label) {
      label.addEventListener('click', function() {
        setTimeout(function() {
          document.querySelectorAll('.product .variant__button-label, .product label.variant__button-label').forEach(function(lbl) {
            var inp = lbl.previousElementSibling;
            if (!inp || inp.tagName !== 'INPUT') { inp = lbl.parentElement ? lbl.parentElement.querySelector('input') : null; }
            var checked = inp && inp.checked;
            if (checked) { lbl.style.setProperty('border', '2px solid #685F5A', 'important'); lbl.style.setProperty('background', 'rgba(104,95,90,0.04)', 'important'); lbl.style.setProperty('font-weight', '600', 'important'); }
            else { lbl.style.setProperty('border', '1.5px solid #E8E2DC', 'important'); lbl.style.setProperty('background', 'transparent', 'important'); lbl.style.setProperty('font-weight', 'normal', 'important'); }
            lbl.style.setProperty('border-radius', '10px', 'important');
            if (lbl.querySelector('img')) { lbl.style.setProperty('padding', '4px', 'important'); }
          });
        }, 50);
      });
    });
  }

  function setupThumbnailListeners() {
    document.querySelectorAll('.product__thumbnail').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setTimeout(function() {
          var isMobile = window.innerWidth <= 1023;
          document.querySelectorAll('.product__thumbnail').forEach(function(t) {
            var isActive = t.getAttribute('aria-current') === 'true';
            if (isMobile) {
              t.style.cssText = 'width:10px!important;height:10px!important;flex:0 0 10px!important;min-width:10px!important;min-height:10px!important;max-width:10px!important;max-height:10px!important;border-radius:50%!important;opacity:1!important;overflow:hidden!important;outline:none!important;border:none!important;padding:0!important;aspect-ratio:1/1!important;transition:background 0.25s ease,transform 0.25s ease!important;';
              t.style.setProperty('background', isActive ? '#FFFFFF' : 'rgba(255,255,255,0.5)', 'important');
              if (isActive) t.style.setProperty('transform', 'scale(1.25)', 'important');
              else t.style.setProperty('transform', 'none', 'important');
              t.querySelectorAll('img, picture, svg, video, .media, [class*="media"]').forEach(function(child) {
                child.style.setProperty('display', 'none', 'important');
                child.style.setProperty('width', '0', 'important');
                child.style.setProperty('height', '0', 'important');
              });
            } else {
              t.style.border = 'none'; t.style.boxShadow = 'none'; t.style.overflow = 'visible';
              t.style.background = 'transparent'; t.style.opacity = isActive ? '1' : '0.5';
              t.style.outline = isActive ? '2.5px solid #685F5A' : 'none'; t.style.outlineOffset = '-1px';
            }
          });
          if (isMobile) fixMobileGallery();
        }, 100);
      });
    });
  }

  function setupStickyBar() {
    var stickyForm = document.querySelector('product-sticky-form, .product-sticky-form');
    if (!stickyForm) return;
    stickyForm.style.opacity = '0'; stickyForm.style.visibility = 'hidden';
    stickyForm.style.pointerEvents = 'none'; stickyForm.style.transform = 'translateY(100%)';
    stickyForm.style.transition = 'all 0.3s ease';
    var card = stickyForm.querySelector('.product-sticky-form__card');
    if (card) { card.style.opacity = '0'; card.style.visibility = 'hidden'; }
    var addToCartBtn = document.querySelector('.product-form__submit, button[name="add"]');
    if (!addToCartBtn) return;

    window.addEventListener('scroll', function() {
      var rect = addToCartBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyForm.style.opacity = '1'; stickyForm.style.visibility = 'visible';
        stickyForm.style.pointerEvents = 'auto'; stickyForm.style.transform = 'translateY(0)';
        if (card) { card.style.opacity = '1'; card.style.visibility = 'visible'; }
        stickyForm.querySelectorAll('.button--primary, button[name="add"], .button').forEach(function(btn) {
          btn.style.cssText = 'background:#D16014!important;color:#FFFFFF!important;border:none!important;border-radius:12px!important;overflow:hidden!important;box-shadow:none!important;outline:none!important;';
          btn.querySelectorAll('*').forEach(function(child) {
            if (child.classList.contains('btn-fill')) { child.style.display = 'none'; }
            else { child.style.borderRadius = '12px'; child.style.border = 'none'; child.style.outline = 'none'; child.style.boxShadow = 'none'; child.style.background = 'transparent'; }
          });
        });
      } else {
        stickyForm.style.opacity = '0'; stickyForm.style.visibility = 'hidden';
        stickyForm.style.pointerEvents = 'none'; stickyForm.style.transform = 'translateY(100%)';
        if (card) { card.style.opacity = '0'; card.style.visibility = 'hidden'; }
      }
    }, { passive: true });
  }

  function buildCustomMegaMenu() {
    var megaMenus = document.querySelectorAll('.mega-menu, .header__submenu');
    if (!megaMenus.length) return;

    megaMenus.forEach(function(menu) {
      if (menu.querySelector('.lykyn-mega-content')) return;

      var singleLayerImg = 'https://cdn.shopify.com/s/files/1/0558/2661/2279/files/black-single-header.png?v=1785848730&width=400';
      var doubleLayerImg = 'https://cdn.shopify.com/s/files/1/0558/2661/2279/files/black-double-header.png?v=1785848730&width=400';

      var cfg = window.lykynConfig || {};
      var singleLayerUrl = cfg.singleLayerUrl || '/products/smart-mushroom-grow-box';
      var stillAirUrl = cfg.stillAirUrl || '/products/still-air-box';
      var growKitUrl = cfg.growKitUrl || '/products/smart-mushroom-grow-box';

      var html = '<div class="lykyn-mega-content">';
      html += '<div class="lykyn-mega-products">';
      html += '<a href="' + singleLayerUrl + '" class="lykyn-mega-card">';
      if (singleLayerImg) html += '<img src="' + singleLayerImg + '" alt="Single Layer" width="100" height="100" style="width: 100px;">';
      html += '<span class="lykyn-mega-card__title">Single Layer</span>';
      html += '<span class="lykyn-mega-card__sub">1 Block</span>';
      html += '</a>';
      html += '<a href="' + singleLayerUrl + '?variant=double" class="lykyn-mega-card">';
      if (doubleLayerImg) html += '<img src="' + doubleLayerImg + '" alt="Double Layer" width="120" height="120">';
      html += '<span class="lykyn-mega-card__title">Double Layer</span>';
      html += '<span class="lykyn-mega-card__sub">2 Blocks</span>';
      html += '</a>';
      html += '</div>';
      html += '<div class="lykyn-mega-links">';
      html += '<div class="lykyn-mega-col">';
      html += '<p>Mushrooms</p>';
      html += '<ul>';
      html += '<li><a href="/collections/mushroom-fruiting-blocks">Mushroom Fruiting Blocks</a></li>';
      html += '<li><a href="/collections/mushroom-liquid-culture">Liquid Culture</a></li>';
      html += '</ul>';
      html += '</div>';
      html += '<div class="lykyn-mega-col">';
      html += '<p>Gear</p>';
      html += '<ul>';
      html += '<li><a href="' + growKitUrl + '">Smart Mushroom Grow Box</a></li>';
      html += '<li><a href="' + stillAirUrl + '">Still Air Box</a></li>';
      html += '</ul>';
      html += '</div>';
      html += '<div class="lykyn-mega-col">';
      html += '<p>Resources</p>';
      html += '<ul>';
      html += '<li><a href="/pages/how-it-works">How It Works</a></li>';
      html += '<li><a href="/pages/mushroom-health-benefits">Mushroom Health Benefits</a></li>';
      html += '</ul>';
      html += '</div>';
      html += '</div>';
      html += '</div>';

      var originalChildren = menu.children;
      for (var i = 0; i < originalChildren.length; i++) {
        originalChildren[i].style.display = 'none';
      }
      menu.insertAdjacentHTML('afterbegin', html);
    });
  }

  function setupMegaMenuHoverDelay() {
    var menuDetails = document.querySelectorAll('.header__menu details');
    if (!menuDetails.length) return;

    menuDetails.forEach(function(details) {
      if (details.dataset.lykynHover) return;
      details.dataset.lykynHover = 'true';

      var closeTimer = null;
      var DELAY = 500;

      details.addEventListener('mouseenter', function() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });

      details.addEventListener('mouseleave', function() {
        if (details.hasAttribute('open')) {
          closeTimer = setTimeout(function() { details.removeAttribute('open'); closeTimer = null; }, DELAY);
        }
      });

      var megaMenu = details.querySelector('.mega-menu, .header__submenu');
      if (megaMenu) {
        megaMenu.addEventListener('mouseenter', function() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        });
        megaMenu.addEventListener('mouseleave', function() {
          closeTimer = setTimeout(function() { details.removeAttribute('open'); closeTimer = null; }, DELAY);
        });
      }
    });
  }

  function fixCollectionPage() {
    document.querySelectorAll('facets-sticky, .facets-sticky-intersection, [class*="facet-sticky"], [class*="facet-floating"]').forEach(function(el) {
      el.style.cssText = 'display:none!important;visibility:hidden!important;height:0!important;overflow:hidden!important;';
    });
    document.querySelectorAll('.card .media [class*="slider"], .card .media [class*="slide"], .card [class*="media-slider"]').forEach(function(el) {
      el.style.transform = 'none'; el.style.transition = 'none'; el.style.animation = 'none';
    });
    document.querySelectorAll('motion-list > *').forEach(function(el) { el.style.opacity = '1'; el.style.transform = 'none'; });
  }

  function fixMobileGallery() {
    if (window.innerWidth > 1023) return;

    function resizeToImage() {
      var imgs = document.querySelectorAll('.product__media img, .product .media img');
      if (!imgs.length) return;

      imgs.forEach(function(img) {
        var container = img.closest('.product__media') || img.closest('.media');
        if (!container) return;

        if (!img.complete || !img.naturalWidth) {
          img.addEventListener('load', function() { resizeToImage(); });
          return;
        }

        var containerWidth = container.offsetWidth || container.clientWidth || 394;
        var ratio = img.naturalHeight / img.naturalWidth;
        var targetHeight = Math.round(containerWidth * ratio);

        container.style.setProperty('height', targetHeight + 'px', 'important');
        container.style.setProperty('min-height', '0', 'important');
        container.style.setProperty('max-height', targetHeight + 'px', 'important');
        container.style.setProperty('aspect-ratio', 'unset', 'important');
        container.style.setProperty('overflow', 'hidden', 'important');

        var slide = container.closest('.slider__slide') || container.closest('.product__media-item');
        if (slide) {
          slide.style.setProperty('height', targetHeight + 'px', 'important');
          slide.style.setProperty('min-height', '0', 'important');
          slide.style.setProperty('max-height', targetHeight + 'px', 'important');
        }
      });

      var slider = document.querySelector('.product .slider, .product .slider-mobile-gutter, .product__media-list');
      var firstImg = document.querySelector('.product__media img');
      if (slider && firstImg && firstImg.complete && firstImg.naturalWidth) {
        var sw = slider.offsetWidth || slider.clientWidth || 394;
        var sh = Math.round(sw * (firstImg.naturalHeight / firstImg.naturalWidth));
        slider.style.setProperty('height', sh + 'px', 'important');
        slider.style.setProperty('min-height', '0', 'important');
        slider.style.setProperty('max-height', sh + 'px', 'important');
      }
    }

    resizeToImage();
    setTimeout(resizeToImage, 300);

    var gallery = document.querySelector('.product__gallery-container');
    if (gallery) {
      gallery.style.setProperty('position', 'relative', 'important');
    }

    var dotsEl = document.querySelector('media-dots');
    if (dotsEl) {
      var wrapper = dotsEl.parentElement;
      if (wrapper) {
        wrapper.style.setProperty('position', 'absolute', 'important');
        wrapper.style.setProperty('bottom', '12px', 'important');
        wrapper.style.setProperty('left', '0', 'important');
        wrapper.style.setProperty('right', '0', 'important');
        wrapper.style.setProperty('z-index', '10', 'important');
        wrapper.style.setProperty('height', 'auto', 'important');
        wrapper.style.setProperty('min-height', '0', 'important');
        wrapper.style.setProperty('padding', '0', 'important');
      }
    }
  }

  function init() { applyLykynStyles(); setupRadioListeners(); setupVariantListeners(); setupThumbnailListeners(); setupStickyBar(); fixCollectionPage(); fixMobileGallery(); buildCustomMegaMenu(); setupMegaMenuHoverDelay(); }

  function setupMenuListeners() {
    document.querySelectorAll('.header__menu details').forEach(function(d) {
      d.addEventListener('toggle', function() { setTimeout(buildCustomMegaMenu, 50); setTimeout(setupMegaMenuHoverDelay, 100); });
      d.addEventListener('mouseenter', function() { setTimeout(buildCustomMegaMenu, 50); setTimeout(setupMegaMenuHoverDelay, 100); });
    });
  }

  function bootstrap() {
    requestAnimationFrame(function() {
      init();
      setupMenuListeners();
      // Dinamik içerik (subscription widget vb.) için tek gecikmeli retry
      setTimeout(function() {
        applyLykynStyles();
        fixPrice();
        fixCollectionPage();
        fixMobileGallery();
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // MutationObserver — debounce ile DOM değişikliklerini izle
  var debounceTimer;
  var observer = new MutationObserver(function(mutations) {
    var needsUpdate = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && ((node.classList && (node.classList.contains('purchase-options-wrapper') || node.classList.contains('purchase-option-wrapper') || node.classList.contains('mega-menu'))) || (node.querySelector && (node.querySelector('.purchase-options-wrapper') || node.querySelector('.mega-menu'))))) {
            needsUpdate = true;
            break;
          }
        }
      }
      if (needsUpdate) break;
    }
    if (needsUpdate) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        applyLykynStyles();
        fixMobileGallery();
        buildCustomMegaMenu();
      }, 200);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
